import * as React from "react";

const Manager = () => (
  <section id="manager" className="border-t border-stone-200 bg-white">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.2em] text-stone-500">
          Led by
        </p>
      </div>
      <div className="lg:col-span-9">
        <div className="flex flex-col sm:flex-row gap-8 sm:gap-10 sm:items-start">
          <div className="shrink-0">
            <img
              src="/img/felipe.png"
              alt="Felipe Lima"
              className="w-28 h-28 sm:w-32 sm:h-32 rounded-full object-cover object-[50%_5%]"
            />
          </div>
          <div className="max-w-2xl">
            <h2 className="font-serif text-3xl sm:text-4xl text-stone-900 leading-tight">
              Felipe Lima
            </h2>
            <p className="mt-2 text-sm uppercase tracking-wider text-stone-500">
              Investor & Researcher
            </p>
            <p className="mt-6 text-lg text-stone-700 leading-relaxed font-light">
              Felipe leads research and capital allocation at Huskly. Software
              engineer by background and crypto native, with two decades of
              experience building systems at the intersection of finance and
              technology — from large-scale data infrastructure to discretionary
              and systematic trading.
            </p>
            <a
              href="https://felipe.lima.gl"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-stone-700 hover:text-stone-900 transition-colors"
            >
              felipe.lima.gl <span aria-hidden>→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Manager;
